// frontend-web/src/pages/Admin/EditCaseStudy.jsx
import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate, useParams } from "react-router-dom";

export default function EditCaseStudy() {
  const { id } = useParams();
  const nav = useNavigate();

  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [contentText, setContentText] = useState("");
  const [file, setFile] = useState(null);
  const [classId, setClassId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    loadMeta();
    loadCaseStudy();
  }, [id]);

  async function loadMeta() {
    try {
      const res = await api.get("/admin/classes");
      setClasses(res.data || []);
      const subRes = await api.get("/admin/subjects");
      setSubjects(subRes.data || []);
    } catch (e) {
      console.error(e);
    }
  }

  async function loadCaseStudy() {
    setLoading(true);
    try {
      const res = await api.get(`/admin/case-study/${id}`);
      const data = res.data;
      setTitle(data.title || "");
      setContentText(data.content_text || "");
      setClassId(data.class_id || "");
      setSubjectId(data.subject_id || "");
    } catch (err) {
      console.error(err);
      alert("Failed to load case study");
    } finally {
      setLoading(false);
    }
  }

  const onSave = async () => {
    const fd = new FormData();
    fd.append("title", title);
    fd.append("content_text", contentText);
    fd.append("class_id", classId);
    fd.append("subject_id", subjectId);
    if (file) fd.append("file", file);

    try {
      await api.put(`/admin/case-study/${id}`, fd, { headers: { "Content-Type": "multipart/form-data" }});
      alert("Saved");
      nav("/admin/case-study");
    } catch (err) {
      console.error(err);
      alert("Save failed");
    }
  };

  if (loading) return <div style={{ padding: 20 }}>Loading…</div>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Edit Case Study</h2>
      <div style={{ maxWidth: 700 }}>
        <label>Title</label>
        <input style={{ width: "100%", padding: 8 }} value={title} onChange={e => setTitle(e.target.value)} />

        <label>Class</label>
        <select style={{ width: "100%", padding: 8 }} value={classId} onChange={e => setClassId(e.target.value)}>
          <option value="">Select Class</option>
          {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>

        <label>Subject</label>
        <select style={{ width: "100%", padding: 8 }} value={subjectId} onChange={e => setSubjectId(e.target.value)}>
          <option value="">Select Subject</option>
          {subjects.filter(s => s.class_id === Number(classId)).map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>

        <label>Content</label>
        <textarea style={{ width: "100%", minHeight: 160, padding: 8 }} value={contentText} onChange={e => setContentText(e.target.value)} />

        <label>File (PDF / PNG / JPG)</label>
        <input type="file" onChange={e => setFile(e.target.files[0])} />

        <div style={{ marginTop: 12 }}>
          <button onClick={onSave}>Save</button>
          &nbsp;
          <button onClick={() => nav("/admin/case-study")}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
